$(document).ready(function () {
    $(".men-btn").on("click", function () {
        $("#shopify-section-429ac0d1-854d-4318-aec3-d3d4ed662061").show(), $("#shopify-section-3ba5b6a5-94fc-415d-8c85-bec81a795ac5").hide();
    });
}),
    $(document).ready(function () {
        $(".women-button").on("click", function () {
            $("#shopify-section-429ac0d1-854d-4318-aec3-d3d4ed662061").hide(), $("#shopify-section-3ba5b6a5-94fc-415d-8c85-bec81a795ac5").show();
        });
    }),
    $(document).ready(function () {
        $(".men-btn").on("click", function () {
            $(".women-button").removeClass("actived"), $(".men-btn").addClass("actived");
        }),
            $(".women-button ").on("click", function () {
                $(".women-button").addClass("actived"), $(".men-btn").removeClass("actived");
            });
    }),
    $(document).ready(function () {
        var n = 0;
        jQuery(document).ready(function (e) {
            e(window).scroll(function () {
                var c = e(window).scrollTop();
                // console.log(c);
                // if(c==0 || c<10){
                //    e("#headerWrapper").removeClass("shift"), e(".usf-sr-config").removeClass("filter");
                // } else {
                //   c > n ? (e("#headerWrapper").addClass("shift"), e(".usf-sr-config").addClass("filter")) : c < n && (e("#headerWrapper").removeClass("shift"), e(".usf-sr-config").removeClass("filter")), (n = c);
                // }
              if(c>=55) {
                e('#headerWrapper').addClass("sticky-header");
                e('.st-search-root').addClass("scroll-down");
              } else {
                e('#headerWrapper').removeClass("sticky-header");
                e('.st-search-root').removeClass("scroll-down");
              }
            });
        });
    });

    $(document).ready(function () {
        $('.menu-ham-additional').on('click', function() {
          if($('#myModal').hasClass('open-modal')){
            $('#myModal').removeClass('open-modal');
          } else {
            $('#myModal').addClass('open-modal');
          }
        })
        $('.desktop-modal .desktop-modal-content .modal-close-btn img').on('click',function() {
          if($('#myModal').hasClass('open-modal')){
            $('#myModal').removeClass('open-modal');
          } else {
            $('#myModal').addClass('open-modal');
          }
        })
    }); 

  $(document).ready(function () {
    $('.search-toggle-img-btn').on('click', function() {
      if($('.st-search-box.hidden-desktop').hasClass('show-search')) {
          $('.st-search-box.hidden-desktop').removeClass('show-search');
      } else {
          $('.st-search-box.hidden-desktop').addClass('show-search');
      }
    })
    $('.mob-search-custom-close').on('click', function() {
      if($('.st-search-box.hidden-desktop').hasClass('show-search')) {
          $('.st-search-box.hidden-desktop').removeClass('show-search');
      } else {
          $('.st-search-box.hidden-desktop').addClass('show-search');
      }
    })
  });
